import { all, call, put, takeLatest } from 'redux-saga/effects';
import { logger } from '../../helpers/logger';
import actions from './actions';
import startAppSettingsActions from '../startAppSettings/actions';
import countriesSettingsActions from '../countriesSettings/actions';
import metabaseActions from '../metabase/actions';
import { getStartAppSettings } from '../startAppSettings/saga';
import { loadCountriesSettings } from '../countriesSettings/saga';
import { loadMetabaseSettings } from '../metabase/saga';

function* loadMetabaseSettingsSaga(): Generator<any, void, any> {
  yield put(metabaseActions.loadMetabaseRequest());
  yield call(loadMetabaseSettings);
}

function* startAppSettingsSaga(): Generator<any, void, any> {
  yield put(startAppSettingsActions.getStartAppSettings());
  yield call(getStartAppSettings);
}

function* loadCountriesSettingsSaga(): Generator<any, void, any> {
  yield put(countriesSettingsActions.loadCountriesSettingsRequest());
  yield call(loadCountriesSettings);
}

function* appUserBootstrapSuccess(): Generator<any, void, any> {
  yield put(actions.appUserBootstrapSuccess());
}

function* appUserBootstrapError(): Generator<any, void, any> {
  yield put(actions.appUserBootstrapError());
}

function* appUserBootstrap(): Generator<any, void, any> {
  try {
    yield call(startAppSettingsSaga);
    yield call(loadCountriesSettingsSaga);
    yield call(loadMetabaseSettingsSaga);

    yield call(appUserBootstrapSuccess);
  } catch (e) {
    logger.error(e);
    yield call(appUserBootstrapError);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.APP_USER_BOOTSTRAP, appUserBootstrap)]);
}
